import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  protected todayDate: Date = new Date();

  private config: { version: string };
  _versionApp: string;
  constructor(
    private readonly http: HttpClient) {
  }

  ngOnInit() {
    this.getVersionApp();
  }

  getVersionApp() {
    ///assets/config/config.json
    this.config = require('./../../../../assets/config/config.json');
    console.log(this.config.version);

    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');

    this.http
      .get<{ version: string }>("/assets/config/config.json", { headers })
      .subscribe(config => {
        this._versionApp =  config.version;
      });
  }


}
